module.exports = __webpack_public_path__ + "static/media/youtube.2df91fc1.svg";